import request from '@/utils/request';

// 管理员登录接口
export function adminLogin(username: string, password: string) {
  return request({
    url: '/admin/auth/login',
    method: 'post',
    data: {
      username,
      password
    }
  });
}